/**
 * This holds all API routes.
 */
const API = {
    LOGIN: '/login',
    USER: {
		PROFILE: "/user-info",
	},
};

export default API;
